import React from 'react';

import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { userInfo, setUserInfo } = useAuth();
  const [isChecking, setIsChecking] = React.useState(true);
  
  React.useEffect(() => {
    if (!userInfo) {
      fetch("/api/isauth", {
        method: "GET",
        credentials: 'include' // Include cookies for OIDC session
      }).then(async (res) => {
        console.log('Auth check status:', res.status);
        if (!res.ok) {
          // Redirect to login page for OIDC authentication
          console.log('Not authenticated - redirecting to login');
          window.location.href = "/login";
        } else {
          const resJson = await res.json();
          console.log('User authenticated:', resJson.email);
          setUserInfo({
            sub: resJson.sub,
            name: resJson.name,
            profile: resJson.profile,
            locale: resJson.locale,
            email: resJson.email,
            nickname: resJson.nickname,
            preferred_username: resJson.preferred_username,
            given_name: resJson.given_name,
            family_name: resJson.family_name,
            zoneinfo: resJson.zoneinfo,
            email_verified: resJson.email_verified
          });
          setIsChecking(false);
        }
      }).catch((error) => {
        console.error('Auth check failed:', error);
        window.location.href = "/login";
      });
    } else {
      setIsChecking(false);
    }
  }, [userInfo, setUserInfo]);
  
  // Show loading while checking authentication
  if (isChecking) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Checking authentication...</div>;
  }

  // If authenticated, render the children (the protected component)
  if (userInfo)
    return <>{children}</>;
  else
    return<></>
};
